import React from "react";
import { useTranslation } from "react-i18next";
import AppNav from "../components/appNav";
import Footer from "../components/footer";
import Breadcrumb from "../components/Breadcrumb";
import ProductPageBody from "../components/ProductPageBody";

const ProductivityPage = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-paper text-ink">
      <header className="sticky top-0 z-50 bg-paper/95 backdrop-blur-[2px] border-b border-ink-14">
        <AppNav />
      </header>
      <Breadcrumb
        parents={[
          { to: "/", label: "KODE" },
          { to: "/ai-data", label: t("kode.nav.aiData") },
        ]}
        current={t("kode.products.productivity.name")}
      />
      <main>
        <ProductPageBody productKey="productivity" />
        <Footer />
      </main>
    </div>
  );
};

export default ProductivityPage;
